import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/send-express.png';
var _withScopeId = function (n) { return (_pushScopeId("data-v-77444d04"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "wrap" };
var _hoisted_2 = { class: "content" };
var _hoisted_3 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("img", {
    src: _imports_0,
    alt: ""
}, null, -1); });
var _hoisted_4 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("p", { class: "tip" }, "快递呼叫成功，正在匹配配送小哥上门取货", -1); });
var _hoisted_5 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("p", { class: "tip" }, [
    /*#__PURE__*/ _createTextVNode(" 如有疑问或催单请拨打"),
    /*#__PURE__*/ _createElementVNode("a", {
        style: { color: '#3DABA4' },
        href: "tel:95538"
    }, "95538")
], -1); });
var _hoisted_6 = /*#__PURE__*/ _createTextVNode("返回首页");
import { NavBar, Button, Icon } from "vant";
import router from "../../router";
export default /*#__PURE__*/ _defineComponent({
    __name: 'SendingExpressSuccess',
    setup: function (__props) {
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(NavBar), {
                    title: "发快递",
                    onClickLeft: _cache[0] || (_cache[0] = function () { })
                }, {
                    left: _withCtx(function () { return [
                        _createVNode(_unref(Icon), {
                            color: "rgba(0,0,0,0.9)",
                            name: "arrow-left",
                            size: "24"
                        })
                    ]; }),
                    _: 1
                }),
                _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    _hoisted_4,
                    _hoisted_5,
                    _createVNode(_unref(Button), {
                        class: "submit-btn",
                        style: _normalizeStyle({ marginTop: '0.96rem', border: '2px solid #eee' }),
                        block: "",
                        round: "",
                        onClick: _cache[1] || (_cache[1] = function ($event) { return (_unref(router).push('/salesman-personal-center')); })
                    }, {
                        default: _withCtx(function () { return [
                            _hoisted_6
                        ]; }),
                        _: 1
                    }, 8, ["style"])
                ])
            ]));
        };
    }
});
